import { useTheme } from '../../styles/ThemeContext';

/**
 * Modal to display packing guidelines
 */
export function GuidelinesModal({ isOpen, onClose, guidelinesData }) {
  const { theme } = useTheme();
  const c = theme.colors;

  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: c.overlay, zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: c.bgCard, border: '1px solid ' + c.border, width: '100%', maxWidth: 700, maxHeight: '85vh', display: 'flex', flexDirection: 'column', borderRadius: 4 }}
      >
        <div style={{ padding: '16px 20px', borderBottom: '1px solid ' + c.border, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ fontWeight: 600, fontSize: 15 }}>📋 Packing Guidelines</div>
          <button onClick={onClose} style={{ ...theme.btnG, padding: '4px 10px', fontSize: 12 }}>✕</button>
        </div>
        <div style={{ padding: '20px 24px', overflow: 'auto', flex: 1 }}>
          {guidelinesData.map((line, i) => {
            return (
              <div
                key={i}
                style={{
                  marginBottom: 10,
                  ...(i === 0
                    ? { fontSize: 18, fontWeight: 700, color: c.accent, marginBottom: 6 }
                    : i === 1
                    ? { fontSize: 13, fontWeight: 600, marginBottom: 12 }
                    : line.endsWith('Instructions') || line.endsWith('Items') || line === 'General Instructions'
                    ? { fontSize: 12, fontWeight: 700, color: c.accent, marginTop: 16, marginBottom: 4, borderTop: '1px solid ' + c.border, paddingTop: 12 }
                    : line.match(/^\d/)
                    ? { fontSize: 12, paddingLeft: 16, color: c.text }
                    : { fontSize: 12, color: c.textSecondary })
                }}
              >
                {line}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
